import { FC, memo, ReactElement } from 'react'
import { Link } from 'react-router-dom'

import { useI18n } from '../../../hooks'
import { ProductWithVariants } from '../../../types'
import ProductCard from '../../product/productCard'
import Carousel from '../components/sliderCarousel'

import './index.css'

const ProductCarousel: FC<{ products: ProductWithVariants[]; title: string; skipToId?: string; viewAllUrl?: string }> = ({
  products,
  title,
  viewAllUrl,
}): ReactElement => {
  const { t } = useI18n()
  return products.length ? (
    <div className="product-carousel-container">
      <div className="product-carousel-title-container">
        <h1 className="section-title">{title}</h1>
        {viewAllUrl && (
          <Link to={viewAllUrl} className="light product-carousel-view-all">
            {t('Common_viewAll')}
          </Link>
        )}
      </div>
      <Carousel>
        {(viewAllUrl ? products.slice(0, 13) : products).map((item, i) =>
          item ? (
            <div
              key={`product-carousel-${i}`}
              style={{
                width: '100%',
                height: '100%',
                justifyContent: 'center',
              }}
            >
              <ProductCard product={item} />
            </div>
          ) : null
        )}
      </Carousel>
    </div>
  ) : (
    <></>
  )
}

export default memo(ProductCarousel)
